import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Editar escala", -1)
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  class: "m-0 -mt-1 mb-2 text-[11px] font-bold text-neutral50",
  "data-testid": "update-schedule-check-externos-hint"
}
const _hoisted_5 = { class: "flex justify-between gap-2 w-full" }

import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { timezones } from '@/hooks/useCommon'
import { useToast } from 'vue-toastification'
import { ProportionalityRuleType } from '@/Network/Types/Responses/ScheduleUnitResponses'
import { NOT_OUR_TEAM_CHECK_DISABLED_REASON } from '@/constants/ds-attendance.constants'

export default /*#__PURE__*/_defineComponent({
  __name: 'updateSchedule',
  props: {
  scheduleId: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



const modalName = EModals.UPDATE_SCHEDULE
const { modals } = storeToRefs(useModalStore())
const scheduleStore = useScheduleStore()
const modalStore = useModalStore()
const toast = useToast()

const data = ref<{
  timezone: string
  scheduleName: string
  healthUnitId: number
  requiredCheckOurTeam?: boolean
  requiredCheckNotOurTeam?: boolean
  proportionalityRule: ProportionalityRuleType
  doctorHandoverAuthorizationMinutes: number
}>()
const errors = ref<{ timezone: string; scheduleName: string; healthUnitId: string }>({
  healthUnitId: '',
  scheduleName: '',
  timezone: ''
})

const isLoading = ref(false)

onMounted(async () => {
  if (!props.scheduleId) return
  clearErrs()

  try {
    isLoading.value = true
    const schedule = await scheduleStore.getScheduleById(props.scheduleId)
    data.value = {
      healthUnitId: schedule.healthUnit.id,
      scheduleName: schedule.name,
      timezone: schedule.timezone,
      // Q3 — fora do time nunca exige check, mesmo com linha antiga `true`.
      requiredCheckNotOurTeam: false,
      requiredCheckOurTeam: schedule.requiredCheckOurTeam,
      proportionalityRule: schedule.proportionalityRule,
      doctorHandoverAuthorizationMinutes: schedule.doctorHandoverAuthorizationMinutes
    }
  } finally {
    isLoading.value = false
  }
})

const hasError = () => {
  let hasError = false
  if (!data.value?.scheduleName) {
    errors.value.scheduleName = 'Informe um nome para escala'
    hasError = true
  }
  if (!data.value?.healthUnitId) {
    errors.value.healthUnitId = 'Selecione um hospital'
    hasError = true
  }

  return hasError
}

const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
  data.value = undefined
  clearErrs()
}

const handleSubmit = async () => {
  if (!data.value || hasError()) {
    toast.error('Dados inválidos ou não preenchidos')
    return
  }

  try {
    isLoading.value = true
    const {
      healthUnitId,
      scheduleName,
      timezone,
      requiredCheckOurTeam,
      proportionalityRule,
      doctorHandoverAuthorizationMinutes
    } = data.value
    const payload = {
      healthUnitId: Number(healthUnitId),
      payload: {
        name: scheduleName!,
        timezone,
        // Q3 — sempre desligado; o backend também força (PR2).
        requiredCheckNotOurTeam: false,
        requiredCheckOurTeam,
        proportionalityRule,
        doctorHandoverAuthorizationMinutes
      },
      scheduleId: props.scheduleId
    }
    await scheduleStore.update(payload)

    modalStore.alertDescription = 'Escala editada com sucesso!'
    modalStore.toggleModal(modalName)
    modalStore.toggleShowAlert()
  } finally {
    isLoading.value = false
  }
}

const clearErrs = () => {
  errors.value.healthUnitId = ''
  errors.value.scheduleName = ''
  errors.value.timezone = ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    isFilterModal: ""
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(OutlineButton, {
          width: "119px",
          onClick: handleToggleModal,
          text: "Cancelar"
        }),
        _createVNode(FilledButton, {
          disabled: isLoading.value,
          loading: isLoading.value,
          text: "Editar",
          width: "119px",
          onClick: handleSubmit
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      (!data.value || isLoading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_text_field, {
              modelValue: data.value.scheduleName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.scheduleName) = $event)),
              label: "Nome da Escala*",
              class: "w-full",
              color: "primary20",
              variant: "outlined",
              errorMessages: errors.value.scheduleName
            }, null, 8, ["modelValue", "errorMessages"]),
            _createVNode(_component_v_autocomplete, {
              modelValue: data.value.timezone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.timezone) = $event)),
              class: "w-full",
              color: "primary20",
              label: "Fuso Horário",
              theme: "light",
              variant: "outlined",
              items: _unref(timezones)
            }, {
              item: _withCtx(({ props, item }) => [
                _createVNode(_component_v_list_item, _mergeProps(props, {
                  title: item?.raw?.title,
                  subtitle: item?.raw?.subtitle
                }), null, 16, ["title", "subtitle"])
              ]),
              _: 1
            }, 8, ["modelValue", "items"]),
            _createElementVNode("div", {
              title: _unref(NOT_OUR_TEAM_CHECK_DISABLED_REASON),
              class: "opacity-70"
            }, [
              _createVNode(_component_v_checkbox, {
                "model-value": false,
                "data-testid": "update-schedule-check-externos-checkbox",
                density: "compact",
                label: "Habilitar check para externos",
                color: "primary",
                "hide-details": "",
                disabled: ""
              }),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(NOT_OUR_TEAM_CHECK_DISABLED_REASON)), 1)
            ], 8, _hoisted_3),
            _createVNode(_component_v_checkbox, {
              modelValue: data.value.requiredCheckOurTeam,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.requiredCheckOurTeam) = $event)),
              "data-testid": "update-schedule-check-nosso-time-checkbox",
              density: "compact",
              label: "Habilitar check para nosso time",
              color: "primary",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ]))
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})